// src/components/matchInput/InfractionsStep.js
import React from "react";
import { INFRACTION_POINTS } from "../../utils/scoringRules";
import SelectBox from "../../central/SelectBox";
import theme from "../../central/theme";

export default function InfractionsStep({
  infractionsSelected = [],
  setInfractionsSelected,
  cleanSheet = false,
  leagueType,
}) {
  console.log("cleanSheet:", cleanSheet);
  console.log("INFRACTION_POINTS:", INFRACTION_POINTS);

  const infractionsList = ["GK 3+ Save Bonus", "Penalty Save", "Yellow Card", "Penalty Miss", "Own Goal"];

  console.log("InfractionsStep leagueType:", leagueType, "list:", infractionsList);

  const toggle = (name) => {
    const set = new Set(infractionsSelected);
    if (set.has(name)) set.delete(name);
    else set.add(name);
    setInfractionsSelected(Array.from(set));
  };

  return (
    <div style={{ marginTop: 0, maxWidth: "700px" }}>
      <div style={{ fontStyle: "italic", marginBottom: 8 , fontSize: "0.9em"}}>
        <strong>Tap</strong> all that apply</div>

      {infractionsList.map((name) => {
        const isOwnGoal = name === "Own Goal";
        const disabled = isOwnGoal && cleanSheet;
        const selected = infractionsSelected.includes(name);
        return (
          <SelectBox
            key={name}
            selected={selected}
            disabled={disabled}
            onClick={() => !disabled && toggle(name)}
          >
            {name}
          </SelectBox>
        );
      })}
    </div>
  );
}